import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "./AccountingTable.scss";
import Arrow from "../../images/arrow-right-purple.svg";
import ArrowDown from "../../images/arrow-down-purple.svg";
import { useSelector } from "react-redux";
import BaseCustomerTable from "../BaseCustomerTable/BaseCustomerTable";
import AccountingTableDetails from "./AccountingTableDetails";
import AccountingDetailModal from "./AccountingDetailModal";

export default function AccountingTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);
  const [sorting, setSorting] = useState({
    column: "",
    direction: "asc",
  });
  const [openAccordion, setOpenAccordion] = useState(null);
  const [selectedData, setSelectedData] = useState([]);
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const accountingDataStateFilter = useSelector(
    (state) => state.accountingTable.accountingTableFilter
  );

  const pageCount = accountingDataStateFilter
    ? Math.ceil(accountingDataStateFilter.length / rowsPerPage)
    : 0;
  const pageNumbers = Array.from({ length: pageCount }, (_, index) => index);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleOpen = (subAccounts) => {
    setOpen(true);
    setSelectedData([subAccounts]);
  };

  useEffect(() => {
    return () => {
      setSorting({
        column: "",
        direction: "asc",
      });
    };
  }, []);

  function displayName(row) {
    if (row.vacctstructure.piidname) {
      return row.vacctstructure.piidname;
    } else if (row.vacctstructure.businessname) {
      return row.vacctstructure.businessname;
    } else {
      return `${row.vacctstructure.firstName} ${row.vacctstructure.lastName}`;
    }
  }

  return (
    <>
      <AccountingDetailModal
        open={open}
        handleClose={handleClose}
        selectedData={selectedData}
      />
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead>
            <TableRow>
              <TableCell
                align="left"
                className="transaction-table-headers"
                //onClick={() => handleSortClick("type")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Account Type</p>
                  {sorting.column === "type" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell
                align="left"
                className="transaction-table-headers"
                //onClick={() => handleSortClick("type")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Account ID</p>
                  {sorting.column === "type" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              {/* <TableCell
              //onClick={() => handleSortClick("date")}
              >
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Account ID</p>
                  {sorting.column === "date" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell> */}
              <TableCell align="left" className="transaction-table-headers">
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Account Name</p>
                  {sorting.column === "receivingAddress" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>

              <TableCell align="left" className="transaction-table-headers">
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Debit</p>
                  {sorting.column === "type" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>

              <TableCell align="center" className="transaction-table-headers">
                <div className="header-cell-content">
                  <p className="transaction-table-headers">Credit</p>
                  {sorting.column === "fee" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
              <TableCell className="transaction-table-headers " align="right">
                <div className="header-cell-content justify-content-end">
                  <p className="transaction-table-headers">Details</p>
                  {sorting.column === "amount" && (
                    <span className="sort-arrow">
                      {sorting.direction === "asc" ? "▲" : "▼"}
                    </span>
                  )}
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!!accountingDataStateFilter &&
              accountingDataStateFilter
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <React.Fragment key={row.vacctstructure.acctID}>
                    <TableRow>
                      <TableCell style={{ width: 200 }} align="left">
                        <p className="transaction-table-date">
                          {row.vacctstructure.accttypename}
                        </p>
                      </TableCell>
                      <TableCell style={{ width: 200 }} align="left">
                        <p className="transaction-table-date">
                          {row.vacctstructure.acctID}
                        </p>
                      </TableCell>

                      <TableCell style={{ width: 300 }} align="left">
                        <div className="transaction-table-address-container">
                          <p className="transaction-table-date ">
                            {row.vacctstructure.accttypename == "Liability"
                              ? "Wallet - "
                              : row.record.acctlabel}{" "}
                            {displayName(row)}
                          </p>
                        </div>
                      </TableCell>

                      <TableCell style={{ width: 200 }} align="left">
                        <p className="transaction-table-date">
                          {Number(row.vacctstructure.balance) > 0 ? (
                            `$ ${row.vacctstructure.balance / -1}`
                          ) : (
                            <></>
                          )}
                        </p>
                      </TableCell>

                      <TableCell style={{ width: 200 }} align="left">
                        <p className="transaction-table-date ">
                          {Number(row.vacctstructure.balance) < 0 ? (
                            `$ ${row.vacctstructure.balance / -1}`
                          ) : (
                            <></>
                          )}
                        </p>
                      </TableCell>
                      <TableCell style={{ width: 400 }} align="right">
                        <div
                          className="d-flex justify-content-end"
                          onClick={() => handleOpen(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <p className="transaction-table-date">View</p>
                          {openAccordion === index ? (
                            <>
                              {" "}
                              <img src={ArrowDown} alt="View Details" />
                            </>
                          ) : (
                            <img src={Arrow} alt="View Details" />
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                    {openAccordion === index && (
                      <TableRow style={{ width: "100%" }}>
                        <TableCell
                          colSpan={5}
                          className="w100"
                          style={{ width: "100%" }}
                        >
                          <AccountingTableDetails selectedData={selectedData} />
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
          </TableBody>
        </Table>
        <BaseCustomerTable
          page={page}
          onPageChange={handleChangePage}
          pageNumbers={pageNumbers}
        />
      </TableContainer>
    </>
  );
}
